module.exports = __webpack_public_path__ + "static/media/happy-holidays.3f54eece.png";